import { Routes } from '@angular/router'

// Rutas de redirección para URLs de la plataforma anterior.
// Añade aquí las entradas que necesites trasladar al nuevo proyecto.
// Conserva los tokens y parámetros en la redirección cuando proceda.
export const LEGACY_REDIRECTS: Routes = [
    // Ejemplo simple: /old-path  -> /new-path
    { path: 'old-path', redirectTo: '/new-path', pathMatch: 'full' },
    { path: 's/academy', redirectTo: '/c-academy', pathMatch: 'full' },
    // Redirecciones legacy añadidas automáticamente (prefijo /s/)
    { path: 's/private-area', redirectTo: '/home', pathMatch: 'full' },
    { path: 's/c-b2c', redirectTo: '/c-b2c', pathMatch: 'full' },
    { path: 's/c-nexus', redirectTo: '/c-nexus', pathMatch: 'full' },
    { path: 's/company-profile', redirectTo: '/company-profile', pathMatch: 'full' },
    { path: 's/ctop', redirectTo: '/ctop', pathMatch: 'full' },
    { path: 's/ctop-ecommerce', redirectTo: '/ctop-ecommerce', pathMatch: 'full' },
    { path: 's/ecommerce', redirectTo: '/ecommerce', pathMatch: 'full' },
    { path: 's/ecosentino', redirectTo: '/ecosentino', pathMatch: 'full' },
    { path: 's/financialPortal', redirectTo: '/my-financial-portal', pathMatch: 'full' },
    { path: 's/installer-partner-search', redirectTo: '/installer-partner-search', pathMatch: 'full' },
    { path: 's/mycommercialsupportnew', redirectTo: '/sales-support', pathMatch: 'full' },
    { path: 's/mydisplays', redirectTo: '/my-displays', pathMatch: 'full' },
    { path: 's/mydisplaydesignnew', redirectTo: '/my-displays', pathMatch: 'full' },
    { path: 's/mydisplaysnew', redirectTo: '/my-displays', pathMatch: 'full' },
    { path: 's/mygalleriesold', redirectTo: '/my-galleries', pathMatch: 'full' },
    { path: 's/mygalleriesnew', redirectTo: '/my-galleries', pathMatch: 'full' },
    { path: 's/myhomenew', redirectTo: '/home', pathMatch: 'full' },
    { path: 's/myprofile', redirectTo: '/profile', pathMatch: 'full' },
    { path: 's/myprofilenew', redirectTo: '/profile', pathMatch: 'full' },
    { path: 's/myprojectsnew', redirectTo: '/my-projects', pathMatch: 'full' },
    { path: 's/myqualityclaimsnew', redirectTo: '/my-claims', pathMatch: 'full' },
    { path: 's/myrewards-old', redirectTo: '/retail-rewards', pathMatch: 'full' },
    { path: 's/myrewardsnew', redirectTo: '/retail-rewards', pathMatch: 'full' },
    { path: 's/mysamples', redirectTo: '/my-samples', pathMatch: 'full' },
    { path: 's/mysamplesnew', redirectTo: '/my-samples', pathMatch: 'full' },
    { path: 's/mysamplestest', redirectTo: '/my-samples', pathMatch: 'full' },
    { path: 's/mysaleslwc', redirectTo: '/my-sales', pathMatch: 'full' },
    { path: 's/mysalesnew', redirectTo: '/my-sales', pathMatch: 'full' },
    { path: 's/myactiosnew', redirectTo: '/my-points', pathMatch: 'full' },
    { path: 's/mynewclaim', redirectTo: '/new-claim', pathMatch: 'full' },
    { path: 's/mywarrantiesnew', redirectTo: '/warranty-registration', pathMatch: 'full' },
    { path: 's/newrequestdisplay', redirectTo: '/register-display', pathMatch: 'full' },
    { path: 's/new-claims', redirectTo: '/new-claims', pathMatch: 'full' },
    { path: 's/otherservices', redirectTo: '/other-services', pathMatch: 'full' },
    { path: 's/projects', redirectTo: '/projects', pathMatch: 'full' },
    { path: 's/redeem-actios-transfer', redirectTo: '/redeem-actios-transfer', pathMatch: 'full' },
    { path: 's/reqdisplay', redirectTo: '/register-display', pathMatch: 'full' },
    { path: 's/registersale', redirectTo: '/new-sales', pathMatch: 'full' },
    { path: 's/requestdisplay', redirectTo: '/register-display', pathMatch: 'full' },
    { path: 's/requestsamples', redirectTo: '/requestsamples', pathMatch: 'full' },
    { path: 's/requestAppointment', redirectTo: '/requestAppointment', pathMatch: 'full' },
    { path: 's/rewards', redirectTo: '/rewards', pathMatch: 'full' },
    { path: 's/rewards-old', redirectTo: '/rewards', pathMatch: 'full' },
    { path: 's/warranty-registration', redirectTo: '/warranty-registration', pathMatch: 'full' },
    { path: 's/warrantyregistrationnew', redirectTo: '/warranty-registration', pathMatch: 'full' },
    { path: 's/we', redirectTo: '/we', pathMatch: 'full' },
    { path: 's/werewards', redirectTo: '/werewards', pathMatch: 'full' },
    { path: 's/mybonuses', redirectTo: '/my-bonuses', pathMatch: 'full' }
    // Ejemplo con parámetro: /old-section/123 -> /new-section/123
    // Para redirigir parámetros utiliza la misma sintaxis de ruta
    // { path: 'old-section/:id', redirectTo: '/new-section/:id', pathMatch: 'full' },

    // Ejemplo que conserva query params (Angular no los copia automáticamente
    // en redirectTo, si necesitas conservar query params deberías manejarlo
    // mediante un componente intermedio que haga la navegación programática
    // y preserve queryParams.

    // Descomenta si quieres un fallback global hacia 'home'
    // { path: '**', redirectTo: '/home' },
]

/* Uso
   - Para incluir estas rutas en `AppRoutingModule` importa `LEGACY_REDIRECTS` y
     mézclalas donde convenga. Ejemplo (en `app-routing.module.ts`):

     import { LEGACY_REDIRECTS } from './legacy-redirects.routes'

     const routes: Routes = [
         // redirecciones legacy al principio (opcional)
         ...LEGACY_REDIRECTS,

         // resto de rutas existentes
     ]

   - Si prefieres mantenerlas como hijos de una ruta concreta, puedes añadirlas
     dentro del array `children` de la ruta deseada.
*/

export default LEGACY_REDIRECTS